import React from 'react'
import SocialList from '../SocialList/SocialList'
import { BsMegaphone, BsMailbox } from "react-icons/bs";

const TopBar = () => {
  return (
    <div className='top-bar'>
        <div className="container">
            <div className="row align-items-center justify-content-between">
                <div className="col">
                    <ul className='top-bar__data'>
                        <li><BsMegaphone /> <span> +39 0364 591467</span></li>
                        <li><BsMailbox /> <span> info@italimpiantisrl.eu</span></li>
                    </ul>

                </div>
                <div className="col">
{/* <SocialList /> */}
                </div>
            </div>
        </div>
    </div>
  )
}

export default TopBar